import React, { Component } from "react";
import ArTheme from "../argon-ui/Theme";
import argonTheme from "../argon-ui/Theme";
import { View } from "react-native";
import Text from "./TextFont";
import { Picker } from "@react-native-community/picker";
import { getIsRTL } from "../util";

export default class MaterialDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWebTitle: true,
    };
  }
  render() {
    let items = [];
    if (Array.isArray(this.props.data)) {
      items = [...this.props.data];
    }
    return (
      <View>
        {this.props.label != undefined && (
          <Text style={{ marginStart: 20, marginVertical: 10 }}>
            {this.props.label}
          </Text>
        )}
        <Picker
          selectedValue={this.props.value}
          style={{
            paddingStart: 4,
            borderRadius: 4,
            borderColor: argonTheme.COLORS.BORDER,
            height: 44,
            backgroundColor: this.state.showWebTitle ? "transparent" : "#FFF",
            shadowColor: argonTheme.COLORS.BLACK,
            shadowOffset: { width: 0, height: 1 },
            shadowRadius: 2,
            shadowOpacity: 0.05,
            elevation: 2,
            fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "",
            fontSize: 15,
            zIndex: 10,
          }}
          onValueChange={(itemValue, itemIndex) => {
            this.setState({ showWebTitle: itemValue == undefined });
            this.props.onChangeText &&
              this.props.onChangeText(itemValue, itemIndex);
          }}
        >
          {this.props &&
            this.props.value == undefined &&
            this.props.value == null &&
            this.props.label && (
              <Picker.Item
                label={""}
                value={undefined}
                color={ArTheme.COLORS.MUTED}
              />
            )}
          {items.map((o, i) => (
            <Picker.Item key={i} label={o.label} value={o.value} />
          ))}
        </Picker>
        {this.props.label != undefined &&
          this.props.value == undefined &&
          this.state.showWebTitle && (
            <Text
              style={{
                position: "absolute",
                fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "",
                fontSize: 14,
                color: ArTheme.COLORS.MUTED,
                padding: 10,
                textAlignVertical: "center",
                backgroundColor: "#FFF",
                flex: 1,
                width: "100%",
              }}
            >
              {this.props.label}
            </Text>
          )}
      </View>
    );
  }
}
